import { render } from "./BasicSelect.vue?vue&type=template&id=a309dec8&scoped=true"
import script from "./BasicSelect.vue?vue&type=script&lang=js"
export * from "./BasicSelect.vue?vue&type=script&lang=js"

import "./BasicSelect.vue?vue&type=style&index=0&id=a309dec8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a309dec8"]])

export default __exports__